export enum PermissionType {
  workspaceAdmin = 'workspace.admin',
  readWorkspace = 'workspace.read',
  updateWorkspace = 'workspace.update',
  deleteWorkspace = 'workspace.delete',
  manageWorkspacePaymentMethods = 'workspace.paymentMethods.manage',

  workspaceMemberAdmin = 'workspace.members.admin',
  createWorkspaceMember = 'workspace.members.create',
  deleteWorkspaceMember = 'workspace.members.delete',

  databaseAdmin = 'database.admin',
  readDatabase = 'database.read',
  createDatabase = 'database.create',
  updateDatabase = 'database.update',
  deleteDatabase = 'database.delete',
  exportDatabase = 'database.export',
  moveDatabaseProperties = 'database.properties.move',

  databasePropertyAdmin = 'database.property.admin',
  readDatabaseProperty = 'database.property.read',
  createDatabaseProperty = 'database.property.create',
  updateDatabaseProperty = 'database.property.update',
  manageDatabasePropertyMasking = 'database.property.masking.manage',
  deleteDatabaseProperty = 'database.property.delete',

  databaseViewAdmin = 'database.view.admin',
  readDatabaseView = 'database.view.read',
  createDatabaseView = 'database.view.create',
  updateDatabaseView = 'database.view.update',
  deleteDatabaseView = 'database.view.delete',

  databaseSliceAdmin = 'database.slice.admin',
  readDatabaseSlice = 'database.slice.read',
  createDatabaseSlice = 'database.slice.create',
  updateDatabaseSlice = 'database.slice.update',
  deleteDatabaseSlice = 'database.slice.delete',
  updateDatabaseSlicePosition = 'database.slice.update.position',

  itemAdmin = 'database.item.admin',
  readItem = 'database.item.read',
  readItemBaseFilter = 'database.item.read.baseFilter',
  deleteItemBaseFilter = 'database.item.delete.baseFilter',
  createItem = 'database.item.create',
  createItemToBaseFilter = 'database.item.create.baseFilter',
  updateItemValue = 'database.item.update.value',
  updateItemState = 'database.item.update.state',
  updateItemFromBaseFilter = 'database.item.update.baseFilter.from',
  updateItemToBaseFilter = 'database.item.update.baseFilter.to',
  deleteItem = 'database.item.delete',
  
  resourceGroupAdmin = 'resource.group.admin',
  readResourceGroup = 'resource.group.read',
  createResourceGroup = 'resource.group.create',
  updateResourceGroup = 'resource.group.update',
  deleteResourceGroup = 'resource.group.delete',
  moveResourceGroup = 'resource.group.move',

  readPermission = 'permission.read',
  updatePermission = 'permission.update',

  createWebhook = 'webhook.create',
  deleteWebhook = 'webhook.delete',
  updateWebhook = 'webhook.update',
  readWebhook = 'webhook.read',

  webhookListenerAdmin = 'webhook.listener.admin',
  createWebhookListener = 'webhook.listener.create',
  deleteWebhookListener = 'webhook.listener.delete',
  updateWebhookListener = 'webhook.listener.update',
  readWebhookListener = 'webhook.listener.read',

  createLink = 'link.create',
  deleteLink = 'link.delete',
  updateLink = 'link.update',
  readLink = 'link.read',

  conversationAdmin = 'conversation.admin',
  readConversation = 'conversation.read',
  createConversation = 'conversation.create',
  updateConversation = 'conversation.update',
  deleteConversation = 'conversation.delete',

  callRoomAdmin = 'call.room.admin',
  readCallRoom = 'call.room.read',
  createCallRoom = 'call.room.create',
  updateCallRoom = 'call.room.update',
  deleteCallRoom = 'call.room.delete',

  dashboardAdmin = 'dashboard.admin',
  readDashboard = 'dashboard.read',
  createDashboard = 'dashboard.create',
  updateDashboard = 'dashboard.update',
  deleteDashboard = 'dashboard.delete',

  createCron = 'cron.create',
  deleteCron = 'cron.delete',
  updateCron = 'cron.update',
  readCron = 'cron.read',

  folderAdmin = 'folder.admin',
  readFolder = 'folder.read',
  createFolder = 'folder.create',
  updateFolder = 'folder.update',
  deleteFolder = 'folder.delete',

  automationAdmin = 'automation.admin',
  readAutomation = 'automation.read',
  createAutomation = 'automation.create',
  updateAutomation = 'automation.update',
  deleteAutomation = 'automation.delete',

  dashboardItemAdmin = 'dashboard.item.admin',
  createDashboardItem = 'dashboard.item.create',
  deleteDashboardItem = 'dashboard.item.delete',
  updateDashboardItem = 'dashboard.item.update',
  readDashboardItem = 'dashboard.item.read',
  updateDashboardItemPlacement = 'dashboard.item.update.placement',
  updateDashboardItemOptions = 'dashboard.item.update.options',

  readCloudItem = 'cloud.item.read',
  createCloudItem = 'cloud.item.create',
  updateCloudItem = 'cloud.item.update',
  deleteCloudItem = 'cloud.item.delete',

  directConversationAdmin = 'direct.conversation.admin',
  readDirectConversation = 'direct.conversation.read',
  updateDirectConversation = 'direct.conversation.update',

  readApp = 'app.read',
  deleteApp = 'app.delete',
  updateApp = 'app.update',
  createApp = 'app.create',
  appAdmin = 'app.admin',

  appAutomationAdmin = 'automation.app.item.admin',
  readAppAutomation = 'automation.app.item.read',
  createAppAutomation = 'automation.app.item.create',
  updateAppAutomation = 'automation.app.item.update',
  deleteAppAutomation = 'automation.app.item.delete',

  webhookListenerDefinitionAdmin = 'webhook.listener.definition.admin',
  readWebhookListenerDefinition = 'webhook.listener.definition.read',
  createWebhookListenerDefinition = 'webhook.listener.definition.create',
  updateWebhookListenerDefinition = 'webhook.listener.definition.update',
  deleteWebhookListenerDefinition = 'webhook.listener.definition.delete',

  connectionDefinitionAdmin = 'connection.definition.admin',
  readConnectionDefinition = 'connection.definition.read',
  createConnectionDefinition = 'connection.definition.create',
  updateConnectionDefinition = 'connection.definition.update',
  deleteConnectionDefinition = 'connection.definition.delete',

  connectionAdmin = 'connection.admin',
  readConnection = 'connection.read',
  createConnection = 'connection.create',
  updateConnection = 'connection.update',
  deleteConnection = 'connection.delete',

  dynamicFieldDefinitionAdmin = 'dynamic.field.definition.admin',
  readDynamicFieldDefinition = 'dynamic.field.definition.read',
  createDynamicFieldDefinition = 'dynamic.field.definition.create',
  updateDynamicFieldDefinition = 'dynamic.field.definition.update',
  deleteDynamicFieldDefinition = 'dynamic.field.definition.delete',

  automationRunAdmin = 'automation.run.admin',
  createAutomationRun = 'automation.run.create',
  deleteAutomationRun = 'automation.run.delete',
  readAutomationRun = 'automation.run.read',
  updateAutomationRun = 'automation.run.update',

  automationVersionAdmin = 'automation.version.admin',
  createAutomationVersion = 'automation.version.create',
  deleteAutomationVersion = 'automation.version.delete',
  readAutomationVersion = 'automation.version.read',
  updateAutomationVersion = 'automation.version.update',

  userInvitationAdmin = 'user.invitation.admin',
  createUserInvitation = 'user.invitation.create',
  deleteUserInvitation = 'user.invitation.delete',
  updateUserInvitation = 'user.invitation.update',
  readUserInvitation = 'user.invitation.read',

  userGroupAdmin = 'user.group.admin',
  createUserGroup = 'user.group.create',
  updateUserGroup = 'user.group.update',
  deleteUserGroup = 'user.group.delete',
  createGroupMember = 'user.group.member.create',
  deleteGroupMember = 'user.group.member.delete',

  documentAdmin = 'document.admin',
  readDocument = 'document.read',
  createDocument = 'document.create',
  updateDocument = 'document.update',
  deleteDocument = 'document.delete',
  exportDocument = 'document.export',
  commentDocument = 'document.comment',
  mentionInDocument = 'document.mention',
  whiteboardAdmin = 'whiteboard.admin',
  readWhiteboard = 'whiteboard.read',
  createWhiteboard = 'whiteboard.create',
  updateWhiteboard = 'whiteboard.update',
  deleteWhiteboard = 'whiteboard.delete',
  exportWhiteboard = 'whiteboard.export',

  planCapDatabaseViewTable = 'plan.cap.database-view-table',
  planCapDatabaseViewMap = 'plan.cap.database-view-map',
  planCapDatabaseViewForm = 'plan.cap.database-view-form',
  planCapDatabaseViewTimeline = 'plan.cap.database-view-timeline',
  planCapDatabaseViewCalendar = 'plan.cap.database-view-calendar',
  planCapDatabaseViewKanban = 'plan.cap.database-view-kanban',
  planCapDatabaseViewIframe = 'plan.cap.database-view-iframe',

  planCapDashboardItemChart = 'plan.cap.dashboard-item-chart',
  planCapDashboardItemDatabaseView = 'plan.cap.dashboard-item-database-view',
  planCapDashboardItemTimeTracker = 'plan.cap.dashboard-item-time-tracker',
  planCapDashboardItemMap = 'plan.cap.dashboard-item-map',
  planCapDashboardItemAggregatedItemList = 'plan.cap.dashboard-item-aggregated-item-list',
  planCapDashboardItemIndicator = 'plan.cap.dashboard-item-indicator',

  skillAdmin = 'skill.admin',
  readSkill = 'skill.read',
  createSkill = 'skill.create',
  updateSkill = 'skill.update',
  deleteSkill = 'skill.delete',
  publishSkill = 'skill.publish',

  agentAdmin = 'agent.admin',
  readAgent = 'agent.read',
  createAgent = 'agent.create',
  updateAgent = 'agent.update',
  deleteAgent = 'agent.delete',
  publishAgent = 'agent.publish',
  mentionInAgent = 'agent.mention',

  preset = 'permission.preset',
}
